module.exports = __webpack_public_path__ + "assets/img/circleci_finish.264cd3d2.png";